module.exports = __webpack_public_path__ + "static/images/store.0eb8fbb68c8c59182e485b108523a764.svg";